import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Button } from 'primeng/button';
import { SvgIconComponent } from 'angular-svg-icon';
import { _, TranslatePipe, TranslateService } from '@ngx-translate/core';

export interface IDialogDeleteEventData {
  serialNo: string;
}

const EVENT_NO_MARKER = '__EVENT_NO__';

@Component({
  selector: 'gc-dialog-delete-event',
  templateUrl: './dialog-delete-event.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [Button, SvgIconComponent, TranslatePipe],
})
export class DialogDeleteEventComponent {
  private readonly ref = inject(DynamicDialogRef);
  private readonly translateService = inject(TranslateService);
  private readonly data = inject<DynamicDialogConfig<IDialogDeleteEventData>>(DynamicDialogConfig).data!;

  protected readonly serialNo = this.data.serialNo;

  private readonly bodyParts: string[] = this.translateService
    .instant(_(`@@dialog-delete-event__body`), { I18N_VAR_EVENT_NO: EVENT_NO_MARKER })
    .split(EVENT_NO_MARKER);

  protected readonly bodyBefore = this.bodyParts[0];
  protected readonly bodyAfter = this.bodyParts[1] ?? '';

  public close(confirmed = false): void {
    this.ref.close(confirmed);
  }
}
